<template>
  <van-button
    class="ld-button"
    :class="[size ? 'ld-button-' + size : '',
             main ? 'main linear-main1' : '', 
             main2 ? 'main2 linear-main2' : '',
             main3 ? 'main3 bg-main' : '',
             main4 ? 'main4 linear-main4' : '',
             round ? 'round' : '', 
             light ? 'light' : '', 
             plain ? 'plain' : '', 
             gray ? 'gray' : '',
             defaults ? 'default' : '',
             transparent?'transparent':'']"
    :type="type"
    :url="url"
    :icon="icon"
    :loading="loading"
    :disabled="disabled"
    :hairline="hairline"
    :tag="tag"
    :block="block"
    :loading-text="loadingText"
    :loading-type="loadingType"
    :loading-size="loadingSize"
    :to="to"
    :replace="replace"
    @click="handleClick"
    @touchstart="touchStart"
  >
    <slot />
    <p v-if="help">
      <slot name="help" />
    </p>
  </van-button>
</template>

<script>
import { Button } from 'vant'
export default {
  components: {
    [Button.name]: Button
  },
  props: {
    size: {
      type: String,
      default: ''
    }, // 按钮大小 lg md sm
    url: {
      type: String,
      default: ''
    }, //跳转 地址
    disabled: Boolean,
    loading: Boolean, // 加载
    
    main: Boolean, //主题色
    main2: Boolean, //主题色2
    main3: Boolean, //主题色
    main4: Boolean, //主题色4
    light: Boolean, //light主题色4
    gray: Boolean, //灰色
    defaults: Boolean, //白色背景
    transparent:Boolean,//背景透明 白色字体边框
    plain: Boolean,
    round: Boolean,
    type: {
      type:String,
      default:'default'
    },
    tag: String,
    icon: String,
    block:{
      type:Boolean,
      default:false
    } ,
    loadingText: String,
    loadingType: String,
    loadingSize: String,
    to: [String, Object],
    hairline: Boolean,
    replace: Boolean
  },
  data() {
    return {
      help: false
    }
  },
  created() {
    if (this.$slots['help']) this.help = true
  },
  methods: {
    handleClick(evt) { // event: Event
      this.$emit('click', evt)
    },
    touchStart (evt) { // event: TouchEvent
      this.$emit('touchstart', evt)
    }
  }
}
</script>

<style lang="less" scoped>
@deep: ~">>>";
.ld-button {
  width: 100%;
  letter-spacing: 1px;
  text-align: center;
  border: none;
}

.ld-button.weui-btn_disabled {
    opacity: .6;
  // background-image: none;
}

// 按钮大小

// 登陆 查询 支付 确定 完成 等 按钮
.ld-button-lg {
  height: 44px;
  line-height: 44px;
  font-size: @font-size-16;
  border-radius: 22px;
}
// 订单填写 订单详情 底部导航的操作按钮 送审 取消 改签 按钮
.ld-button-md {
  height: 34px;
  line-height: 34px;
  border-radius: 34px;
}
// 订单列表 申请单列表 审批列表 操作按钮（取消 送审 支付 改签）
.ld-button-sm {
  height: 26px;
  line-height: 26px;
  font-size: @font-size-12;
  border-radius: 26px;
}

// party
.ld-button-party {
  height: 40px;
  line-height: 40px;
  width: 40px;
  text-align: center;
  font-size: @font-size-16;
}

// 按钮颜色

// 主题色背景
.main {
  color: @color-text-white;
//   background-blend-mode: normal, normal;
//   box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.56);
}
.main2 {
  color: @color-text-white;
}
.main3,.main4{
  color: @color-text-white;
//   box-shadow: 0 0.06rem 0.16rem 0 rgba(186, 161, 121, 0.46);
}
.light {
  border-radius: 4px;
  color: @color-text-main;
  background-color: @color-background-lightYellow;
}
.gray {
  color: @color-text-white;
  box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, .1);
  background-image: linear-gradient(90deg, #ccc 0%, #ccc 100%), linear-gradient(#ccc, #ccc);
}

// 取消 退票 改签 按钮
.default {
  border: 1px solid #ebedf0;
}
.default:active {
  color: @color-text-black;
  background-color: @color-background-gray;
  filter: none;
}

.plain {
  background-color: @color-text-white;
  border: 1px solid @color-text-main;
  color: @color-text-main;
}

// transparent
.transparent{
  color: @color-text-white;
  border: 1px solid @color-text-white;
  background-color:transparent;
}

.round {
  border-radius: 44px;
}
</style>
